define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function RiqInviteFamiliesModelServiceModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  /**
   * Handles invite families api
   * @function riqInviteFamiliesModelService
   * @param {Object} riqApiService - riqApiService
   * */
  var riqInviteFamiliesModelService = function(riqApiService) {
    var _this = this;
    var STATUSES_MAP = {
      pending: 'sent',
      notInvited: 'unsent',
      connected: 'connected'
    };

    riqApiService.setApiEndpoints({
      getClassroomStatus: 'group_get',
      sendInvitations: 'invitation_send'
    });

    function _filterProfilesByStatus(profiles, status) {
      var userUuid = storeService.getState().user.userUuid;
      var mappedStatus = STATUSES_MAP[status] || '';
      var filteredProfiles = profiles.filter(function(profile) {
        var isGroupOwner = profile.userUuid === userUuid;
        var hasCorrectStatus =
          profile.profileDetails.invitationStatus === mappedStatus;
        return !isGroupOwner && hasCorrectStatus;
      });
      return filteredProfiles;
    }

    function _handleGetClassroomStatus(payload) {
      var group = payload.group;
      storeService.commit([
        {
          stateAlias: 'group',
          mutationId: 'update',
          payload: group
        }
      ]);
      var pending = _filterProfilesByStatus(group.profiles, 'pending');
      var notInvited = _filterProfilesByStatus(group.profiles, 'notInvited');
      var connected = _filterProfilesByStatus(group.profiles, 'connected');
      var totalStudents = pending.length + notInvited.length + connected.length;
      return {
        groupUuid: group.groupUuid,
        totalStudents: totalStudents,
        pending: pending,
        notInvited: notInvited,
        connected: connected
      };
    }

    function _throwError(error) {
      throw error;
    }

    var getClassroomStatus = function getClassroomStatus() {
      var groupUuid = storeService.getState().user.groupUuid;
      return riqApiService
        .get(
          'getClassroomStatus',
          {
            includeOwner: true,
            groupUuid: groupUuid,
            profileDetails: [
              'name',
              'last_name',
              'invitation_status',
              'contact_email',
              'avatar'
            ]
          },
          false
        )
        .then(_handleGetClassroomStatus)
        .catch(_throwError);
    };

    var sendInvitations = function sendInvitations(students) {
      var groupUuid = storeService.getState().user.groupUuid;
      var profileUuids = students.map(function(student) {
        return student.profileUuid;
      });
      return riqApiService.get('sendInvitations', {
        groupUuid: groupUuid,
        profileUuids: profileUuids
      });
    };

    _this.getClassroomStatus = getClassroomStatus;
    _this.sendInvitations = sendInvitations;
  };

  return riqInviteFamiliesModelService;
});
